import AIDisclosureBanner from './AIDisclosureBanner.jsx';

const FOOTER_LINKS = [
  { label: 'Privacy Policy', href: '/privacy' },
  { label: 'Terms of Service', href: '/terms' },
  { label: 'AI Disclosure', href: '/ai-disclosure' },
  { label: 'Gacha Odds', href: '/gacha-odds' },
  { label: 'Safety Resources', href: '/safety' },
  { label: 'Contact', href: '/contact' },
  { label: 'Delete Account', href: '/delete-account' },
];

export default function SiteFooter() {
  return (
    <footer style={{
      borderTop: '1px solid rgba(196,168,130,0.1)',
      padding: '24px 20px',
      background: 'rgba(0,0,0,0.3)',
      textAlign: 'center',
    }}>
      {/* Haley, 2026-08-03: "mount the disclosure somewhere that will not annoy
          us" — footer placement, never over the chat. */}
      <div style={{ maxWidth: '620px', margin: '0 auto 14px', borderRadius: '8px', overflow: 'hidden' }}>
        <AIDisclosureBanner />
      </div>
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: '4px 16px',
        marginBottom: '14px',
      }}>
        {FOOTER_LINKS.map(link => (
          <a
            key={link.href}
            href={link.href}
            style={{
              fontSize: '12px',
              color: '#6a5f4f',
              textDecoration: 'underline',
              textUnderlineOffset: '2px',
              fontFamily: "'Cormorant Garamond', Georgia, serif",
              letterSpacing: '0.3px',
              transition: 'color 0.15s',
              padding: '8px 4px',
              minHeight: '44px',
              display: 'inline-flex',
              alignItems: 'center',
              WebkitTapHighlightColor: 'rgba(196,168,130,0.2)',
              touchAction: 'manipulation',
            }}
            onMouseEnter={e => e.target.style.color = '#a09070'}
            onMouseLeave={e => e.target.style.color = '#6a5f4f'}
          >
            {link.label}
          </a>
        ))}
      </div>

      <p style={{
        fontSize: '11px',
        color: '#2e2820',
        margin: '0 0 4px',
        fontFamily: "'Cormorant Garamond', Georgia, serif",
        letterSpacing: '0.3px',
      }}>
        © 2025–2026 Vocally Yours LLC · Mount Arlington, NJ
      </p>
      <p style={{
        fontSize: '10px',
        color: '#2a2218',
        margin: 0,
        fontFamily: "'Cormorant Garamond', Georgia, serif",
      }}>
        All characters are AI-generated and fictional. MFML is entertainment only — not a substitute for professional support.
        {' '}<a href="/safety" style={{ color: '#3a3028', textDecoration: 'underline' }}>Crisis resources</a>
      </p>
    </footer>
  );
}
